export default __webpack_public_path__ + "static/media/videocam.b481eb43.svg";